/** Canonical top-story categories (homepage chips + admin). */
export const STORY_CATEGORIES = [
  {
    id: 'politics',
    te: 'రాజకీయాలు',
    en: 'Politics',
    ta: 'அரசியல்',
    kn: 'ರಾಜಕೀಯ',
    aliases: [
      'politics',
      'political',
      'రాజకీయాలు',
      'రాజకీయం',
      'రాజకీయ',
      'அரசியல்',
      'ರಾಜಕೀಯ',
    ],
  },
  {
    id: 'news',
    te: 'వార్తలు',
    en: 'News',
    ta: 'செய்திகள்',
    kn: 'ಸುದ್ದಿ',
    aliases: [
      'news',
      'వార్తలు',
      'వార్త',
      'న్యూస్',
      'செய்திகள்',
      'செய்தி',
      'ಸುದ್ದಿ',
      'ಸುದ್ದಿಗಳು',
    ],
  },
  {
    id: 'turmeric',
    te: 'పసుపు పరిమళాలు',
    en: 'Legacy Of TDP',
    ta: 'மஞ்சள்',
    kn: 'ಅರಿಶಿನ',
    aliases: [
      'fragrance of turmeric',
      'legacy of tdp',
      'legacy of TDP',
      'turmeric',
      'pasupu',
      'pasupu parimalalu',
      'పసుపు పరిమళాలు',
      'పసుపుపరిమళాలు',
      'పసుపు',
      'மஞ்சள் வாசனை',
      'மஞ்சள்',
      'ಅರಿಶಿನ ಪರಿಮಳ',
      'ಅರಿಶಿನ',
    ],
  },
];

export const STORY_CATEGORY_IDS = STORY_CATEGORIES.map((c) => c.id);

function norm(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export function getStoryCategoryById(id) {
  return STORY_CATEGORIES.find((c) => c.id === id) || null;
}

export function storyCategoryLabel(id, lang = 'te') {
  const cat = getStoryCategoryById(id);
  if (!cat) return id;
  return cat[lang] || cat.en || cat.te;
}

/** Map free-text / legacy DB values → canonical id. */
export function resolveStoryCategoryId(storyOrCategory, categoryEn) {
  let te = '';
  let en = '';
  if (storyOrCategory && typeof storyOrCategory === 'object') {
    te = storyOrCategory.category || '';
    en = storyOrCategory.categoryEn || storyOrCategory.category_en || '';
  } else {
    te = storyOrCategory || '';
    en = categoryEn || '';
  }

  const candidates = [en, te].map(norm).filter(Boolean);
  if (!candidates.length) return null;

  for (const cat of STORY_CATEGORIES) {
    const aliasSet = new Set(cat.aliases.map(norm));
    aliasSet.add(norm(cat.te));
    aliasSet.add(norm(cat.en));
    aliasSet.add(norm(cat.ta));
    aliasSet.add(norm(cat.kn));
    if (candidates.some((c) => aliasSet.has(c))) return cat.id;
  }

  // Partial match for longer labels typed in admin
  for (const cat of STORY_CATEGORIES) {
    const needles = [cat.te, cat.en, ...cat.aliases].map(norm);
    if (candidates.some((c) => needles.some((n) => n && (c.includes(n) || n.includes(c))))) {
      return cat.id;
    }
  }

  return null;
}

export function storyCategoryFields(id) {
  const cat = getStoryCategoryById(id) || STORY_CATEGORIES[1];
  return {
    category: cat.te,
    categoryEn: cat.en,
  };
}
